import { render, staticRenderFns } from "./approveAccountDialog.vue?vue&type=template&id=901f9cb8&scoped=true&"
import script from "./approveAccountDialog.vue?vue&type=script&lang=js&"
export * from "./approveAccountDialog.vue?vue&type=script&lang=js&"
import style0 from "./approveAccountDialog.vue?vue&type=style&index=0&id=901f9cb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "901f9cb8",
  null
  
)

export default component.exports